import type { CSSObject } from '@emotion/react';

import type {
  ThemeType,
} from '@n3/css-base';

export const createOptionStyle = ({
  fonts,
  colors,
  indents,
}: ThemeType) => (baseCSS: CSSObject, {
  isFocused,
}: {
  isFocused: boolean;
}): CSSObject => ({
  ...baseCSS,
  ...fonts.DEFAULT,
  paddingTop: 4,
  paddingBottom: 4,
  paddingLeft: indents.INDENT_2,
  paddingRight: indents.INDENT_2,
  backgroundColor: isFocused ? colors.ACTION_BACKGROUND : 'transparent',
  color: colors.NEUTRAL_DEFAULT,
  cursor: 'pointer',
  display: 'flex',
  justifyContent: 'space-between',
  ':active': undefined,
});
